module.exports = __webpack_public_path__ + "img/img-i5gam-ct-list4.4d7907e0.png";